export const MODEL_KEYS = {
  FINANCIAL_APPLICATION: "FinancialApplicationExpressionSchema",
  JOINT_ACCOUNT_OWNER: "JointAccountOwnerExpressionSchema",
  KEY_PERSON: "KeyPersonExpressionSchema",
  PERSONAL_ACCOUNT_BENEFICIARY: "PersonalAccountBeneficiaryExpressionSchema",
  FINANCIAL_APPLICATION_DISCLOSURE_ACKNOWLEDGEMENT:
    "FinancialApplicationDisclosureAcknowledgementExpressionSchema",
  DEPOSIT_APPLICATION: "DepositApplicationExpressionSchema",
  CREDIT_AUTHORIZATION: "CreditAuthorizationExpressionSchema",
  UNDERWRITING_RULE_RESULT: "UnderwritingRuleResultExpressionSchema",
} as const;

export const FIELD_KEYS = {
  APPLICANT: {
    LEGAL_FIRST_NAME: "FinancialApplicationExpressionSchema__Applicant__LegalFirstName",
    LEGAL_MIDDLE_NAME: "FinancialApplicationExpressionSchema__Applicant__LegalMiddleName",
    LEGAL_LAST_NAME: "FinancialApplicationExpressionSchema__Applicant__LegalLastName",
    DATE_OF_BIRTH: "FinancialApplicationExpressionSchema__Applicant__DateOfBirth",
    WILL_HAVE_JOINT_ACCOUNT_OWNERS:
      "FinancialApplicationExpressionSchema__Applicant__WillHaveJointAccountOwners",
  },
  IDENTIFICATION: {
    SOCIAL_SECURITY_NUMBER:
      "FinancialApplicationExpressionSchema__Identification__SocialSecurityNumber",
    IS_US_CITIZEN: "FinancialApplicationExpressionSchema__Identification__IsUsCitizen",
    GOVERNMENT_ID_TYPE: "FinancialApplicationExpressionSchema__Identification__GovernmentIdType",
    GOVERNMENT_ID_NUMBER:
      "FinancialApplicationExpressionSchema__Identification__GovernmentIdNumber",
    GOVERNMENT_ID_ISSUING_STATE:
      "FinancialApplicationExpressionSchema__Identification__GovernmentIdIssuingState",
    GOVERNMENT_ID_ISSUING_COUNTRY:
      "FinancialApplicationExpressionSchema__Identification__GovernmentIdIssuingCountry",
    GOVERNMENT_ID_EXPIRY:
      "FinancialApplicationExpressionSchema__Identification__GovernmentIdExpiry",
  },
  CONTACT_INFO: {
    EMAIL_ADDRESS: "FinancialApplicationExpressionSchema__ContactInfo__EmailAddress",
    PHONE_NUMBER: "FinancialApplicationExpressionSchema__ContactInfo__PhoneNumber",
    HOME_ADDRESS: "FinancialApplicationExpressionSchema__ContactInfo__HomeAddress",
  },
  EMPLOYMENT_INFO: {
    EMPLOYMENT_TYPE: "FinancialApplicationExpressionSchema__EmploymentInfo__EmploymentType",
    EMPLOYER: "FinancialApplicationExpressionSchema__EmploymentInfo__Employer",
    JOB_TITLE: "FinancialApplicationExpressionSchema__EmploymentInfo__JobTitle",
    ATTORNEY_BAR_NUMBER: "FinancialApplicationExpressionSchema__EmploymentInfo__AttorneyBarNumber",
  },
  ORGANIZATION_INFO: {
    LEGAL_ORGANIZATION_NAME:
      "FinancialApplicationExpressionSchema__OrganizationInfo__LegalOrganizationName",
    FICTITIOUS_ORGANIZATION_NAME:
      "FinancialApplicationExpressionSchema__OrganizationInfo__FictitiousOrganizationName",
    ORGANIZATION_TYPE: "FinancialApplicationExpressionSchema__OrganizationInfo__OrganizationType",
    EMPLOYER_IDENTIFICATION_NUMBER:
      "FinancialApplicationExpressionSchema__OrganizationInfo__EmployerIdentificationNumber",
    STATE_OF_FORMATION: "FinancialApplicationExpressionSchema__OrganizationInfo__StateOfFormation",
    YEAR_ESTABLISHED: "FinancialApplicationExpressionSchema__OrganizationInfo__YearEstablished",
    ORGANIZATION_PHONE_NUMBER:
      "FinancialApplicationExpressionSchema__OrganizationInfo__OrganizationPhoneNumber",
    ORGANIZATION_EMAIL_ADDRESS:
      "FinancialApplicationExpressionSchema__OrganizationInfo__OrganizationEmailAddress",
    ORGANIZATION_WEBSITE_URL:
      "FinancialApplicationExpressionSchema__OrganizationInfo__OrganizationWebsiteUrl",
    NAICS_CODE: "FinancialApplicationExpressionSchema__OrganizationInfo__NaicsCode",
    FICO_SBSS_SCORE: "FinancialApplicationExpressionSchema__OrganizationInformation__FicoSbssScore",
  },
  PERSONAL_ACCEPTABLE_BUSINESS: {
    USE_PERSONAL_ACCOUNTS_FOR_BUSINESS:
      "FinancialApplicationExpressionSchema__PersonalAcceptableBusiness__UsePersonalAccountsForBusiness",
    PERSONAL_ACCOUNTS_CASH_DEPOSITS:
      "FinancialApplicationExpressionSchema__PersonalAcceptableBusiness__PersonalAccountsCashDeposits",
    PERSONAL_ACCOUNTS_SEND_RECEIVE_WIRES:
      "FinancialApplicationExpressionSchema__PersonalAcceptableBusiness__PersonalAccountsSendReceiveWires",
  },
  ORGANIZATION_ACCEPTABLE_BUSINESS: {
    SEND_RECEIVE_WIRES:
      "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__SendReceiveWires",
    PROHIBITED_ACTIVITIES:
      "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__ProhibitedActivities",
    STORAGE_OF_VALUED_CARDS:
      "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__StorageOfValuedCards",
    GAMBLING: "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__Gambling",
    LOTTERY_TICKETS:
      "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__LotteryTickets",
    ADULT_ENTERTAINMENT_FIREARMS:
      "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__AdultEntertainmentFirearms",
    MARIJUANA_INDUSTRY:
      "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__MarijuanaIndustry",
    CANNABIS_INVESTMENTS:
      "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__CannabisInvestments",
    ILLEGAL_SUBSTANCES:
      "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__IllegalSubstances",
    CRYPTO_EXCHANGES:
      "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__CryptoExchanges",
    CRYPTO_ACTIVITIES:
      "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__CryptoActivities",
    VIRTUAL_CURRENCY:
      "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__VirtualCurrency",
    DEFENSE_CONTRACTORS:
      "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__DefenseContractors",
    PRIVATE_ATMS:
      "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__PrivateATMs",
    CASHING_CHECKS:
      "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__CashingChecks",
    INITIAL_CASH_DEPOSIT:
      "FinancialApplicationExpressionSchema__OrganizationAcceptableBusiness__InitialCashDeposit",
  },
  FINANCIAL_APPLICATION: {
    // Person Information
    PERSON_INFORMATION: "FinancialApplicationExpressionSchema__PersonInformation",

    // Government ID Information
    GOVERNMENT_ID_INFORMATION: "FinancialApplicationExpressionSchema__GovernmentIdInformation",

    // Employment Information
    EMPLOYMENT_INFORMATION: "FinancialApplicationExpressionSchema__EmploymentInformation",

    // Digital Banking Information
    DIGITAL_BANKING_INFORMATION: "FinancialApplicationExpressionSchema__DigitalBankingInformation",

    // Debit Card Information
    DEBIT_CARD_INFORMATION: "FinancialApplicationExpressionSchema__DebitCardInformation",

    // Security Questions Information
    SECURITY_QUESTIONS_INFORMATION:
      "FinancialApplicationExpressionSchema__SecurityQuestionsInformation",

    // Organization Information
    ORGANIZATION_INFORMATION: "FinancialApplicationExpressionSchema__OrganizationInformation",

    // Personal Account Acceptable Use
    PERSONAL_ACCOUNT_ACCEPTABLE_USE:
      "FinancialApplicationExpressionSchema__PersonalAccountAcceptableUse",

    // Organization Contact Information
    ORGANIZATION_CONTACT_INFORMATION:
      "FinancialApplicationExpressionSchema__OrganizationContactInformation",

    // Organization Account Acceptable Use
    ORGANIZATION_ACCOUNT_ACCEPTABLE_USE:
      "FinancialApplicationExpressionSchema__OrganizationAccountAcceptableUse",

    // Has Joint Account Owners
    WILL_HAVE_JOINT_ACCOUNT_OWNERS:
      "FinancialApplicationExpressionSchema__WillHaveJointAccountOwners",

    // Will Have Personal Account Beneficiaries
    WILL_HAVE_PERSONAL_ACCOUNT_BENEFICIARIES:
      "FinancialApplicationExpressionSchema__WillHavePersonalAccountBeneficiaries",

    // Applicant Key Person Roles
    IS_BENEFICIAL_OWNER: "FinancialApplicationExpressionSchema__IsBeneficialOwner",
    IS_AUTHORIZED_SIGNER: "FinancialApplicationExpressionSchema__IsAuthorizedSigner",
    IS_CONTROL_PERSON: "FinancialApplicationExpressionSchema__IsControlPerson",

    // Business Tax Return Revenue Fields
    FIRST_YEAR_BUSINESS_TAX_RETURN_ANNUAL_REVENUE:
      "FinancialApplicationExpressionSchema__FirstYearBusinessTaxReturnAnnualRevenue",
    SECOND_YEAR_BUSINESS_TAX_RETURN_ANNUAL_REVENUE:
      "FinancialApplicationExpressionSchema__SecondYearBusinessTaxReturnAnnualRevenue",

    // Risk Review
    PERSONAL_ACCOUNT_RISK_REVIEW: "FinancialApplicationExpressionSchema__PersonalAccountRiskReview",

    // Law Firm Organization Account Risk Review
    LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW:
      "FinancialApplicationExpressionSchema__LawFirmOrganizationAccountRiskReview",

    // Non-Law Firm Organization Account Risk Review
    NON_LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW:
      "FinancialApplicationExpressionSchema__NonLawFirmOrganizationAccountRiskReview",

    // Financial Application Documents
    FINANCIAL_APPLICATION_DOCUMENTS:
      "FinancialApplicationExpressionSchema__FinancialApplicationDocuments",
  },
  JOINT_ACCOUNT_OWNER: {
    // Joint Account Owner
    RELATIONSHIP_TO_PRIMARY_OWNER: "JointAccountOwnerExpressionSchema__RelationshipToPrimaryOwner",
    HOME_ADDRESS_IS_SAME_AS_ACCOUNT_OPENER: "JointAccountOwnerExpressionSchema__HomeAddressIsSameAsAccountOpener",

    // Employment Information
    EMPLOYMENT_INFORMATION: "JointAccountOwnerExpressionSchema__EmploymentInformation",

    // Person Information
    PERSON_INFORMATION: "JointAccountOwnerExpressionSchema__PersonInformation",

    // Digital Banking Information
    DIGITAL_BANKING_INFORMATION: "JointAccountOwnerExpressionSchema__DigitalBankingInformation",

    // Debit Card Information
    DEBIT_CARD_INFORMATION: "JointAccountOwnerExpressionSchema__DebitCardInformation",

    // Government ID Information
    GOVERNMENT_ID_INFORMATION: "JointAccountOwnerExpressionSchema__GovernmentIdInformation",

    // Security Questions Information
    SECURITY_QUESTIONS_INFORMATION:
      "JointAccountOwnerExpressionSchema__SecurityQuestionsInformation",

    // Identity Documents
    IDENTIFICATION_DOCUMENTS: "JointAccountOwnerExpressionSchema__IdentificationDocuments",
  },
  KEY_PERSON: {
    // Key Person
    IS_BENEFICIAL_OWNER: "KeyPersonExpressionSchema__IsBeneficialOwner",
    IS_AUTHORIZED_SIGNER: "KeyPersonExpressionSchema__IsAuthorizedSigner",
    IS_CONTROL_PERSON: "KeyPersonExpressionSchema__IsControlPerson",
    BENEFICIAL_OWNER_PERCENTAGE: "KeyPersonExpressionSchema__BeneficialOwnerPercentage",
    ATTORNEY_BAR_NUMBER: "KeyPersonExpressionSchema__AttorneyBarNumber",

    // Employment Information
    EMPLOYMENT_INFORMATION: "KeyPersonExpressionSchema__EmploymentInformation",

    // Person Information
    PERSON_INFORMATION: "KeyPersonExpressionSchema__PersonInformation",

    // Digital Banking Information
    DIGITAL_BANKING_INFORMATION: "KeyPersonExpressionSchema__DigitalBankingInformation",

    // Debit Card Information
    DEBIT_CARD_INFORMATION: "KeyPersonExpressionSchema__DebitCardInformation",

    // Government ID Information
    GOVERNMENT_ID_INFORMATION: "KeyPersonExpressionSchema__GovernmentIdInformation",

    // Security Questions Information
    SECURITY_QUESTIONS_INFORMATION: "KeyPersonExpressionSchema__SecurityQuestionsInformation",

    // Identity Documents
    IDENTIFICATION_DOCUMENTS: "KeyPersonExpressionSchema__IdentificationDocuments",
  },
  PERSONAL_ACCOUNT_BENEFICIARY: {
    // Personal Account Beneficiary
    RELATIONSHIP_TO_PRIMARY_OWNER:
      "PersonalAccountBeneficiaryExpressionSchema__RelationshipToPrimaryOwner",

    // Person Information
    PERSON_INFORMATION: "PersonalAccountBeneficiaryExpressionSchema__PersonInformation",
  },
  FINANCIAL_APPLICATION_DISCLOSURE_ACKNOWLEDGEMENT: {
    SLUG: "FinancialApplicationDisclosureAcknowledgementExpressionSchema__Slug",
    LABEL: "FinancialApplicationDisclosureAcknowledgementExpressionSchema__Label",
    FILE_URL: "FinancialApplicationDisclosureAcknowledgementExpressionSchema__FileUrl",
    AGREED_SIGNED_AT:
      "FinancialApplicationDisclosureAcknowledgementExpressionSchema__AgreedSignedAt",
  },
  DEPOSIT_APPLICATION: {
    INITIAL_DEPOSIT_AMOUNT: "DepositApplicationExpressionSchema__InitialDepositAmount",
    E_STATEMENTS_OPT_IN: "DepositApplicationExpressionSchema__EStatementsOptIn",
    CHECKS_OPT_IN: "DepositApplicationExpressionSchema__ChecksOptIn",
    WIRES_OPT_IN: "DepositApplicationExpressionSchema__WiresOptIn",
    ACH_OPT_IN: "DepositApplicationExpressionSchema__AchOptIn",
    POSITIVE_PAY_OPT_IN: "DepositApplicationExpressionSchema__PositivePayOptIn",
    REMOTE_DEPOSIT_SCANNER_OPT_IN: "DepositApplicationExpressionSchema__RemoteDepositScannerOptIn",
    CDARS_OPT_IN: "DepositApplicationExpressionSchema__CdarsOptIn",
    INSURED_CASH_SWEEP_OPT_IN: "DepositApplicationExpressionSchema__InsuredCashSweepOptIn",
  },
  CREDIT_AUTHORIZATION: {
    DECISION: "CreditAuthorizationExpressionSchema__Decision",
  },
  UNDERWRITING_RULE_RESULT: {
    RESULT_TYPE: "UnderwritingRuleResultExpressionSchema__ResultType",
    RESULT_COMMENT: "UnderwritingRuleResultExpressionSchema__ResultComment",
  },
} as const;

export const COMPLEX_FIELD_KEYS = {
  IDENTIFICATION_DOCUMENTS: {
    STATE_ISSUED_ID_FRONT: "StateIssuedIdFront",
    STATE_ISSUED_ID_BACK: "StateIssuedIdBack",
    PASSPORT_BIOGRAPHIC_PAGE: "PassportBiographicPage",
    PASSPORT_SIGNATURE_PAGE: "PassportSignaturePage",
  },
  FINANCIAL_APPLICATION_DOCUMENTS: {
    ARTICLES_OF_INCORPORATION_OR_CERTIFICATE_OF_FORMATION_OR_ORGANIZATION:
      "ArticlesOfIncorporationOrCertificateOfFormationOrOrganization",
    BYLAWS: "Bylaws",
    OPERATING_AGREEMENT: "OperatingAgreement",
    PARTNERSHIP_AGREEMENT: "PartnershipAgreement",
    CORPORATE_RESOLUTION: "CorporateResolution",
    MEMBER_OR_PARTNER_RESOLUTION: "MemberOrPartnerResolution",
    SIGNATURE_CARD: "SignatureCard",
    BUSINESS_LICENSE_OR_STATE_REGISTRATION_CERTIFICATE:
      "BusinessLicenseOrStateRegistrationCertificate",
    DBA_OR_ASSUMED_NAME_CERTIFICATE: "DbaOrAssumedNameCertificate",
    DEPOSIT_AGREEMENT_OR_TERMS_AND_CONDITIONS: "DepositAgreementOrTermsAndConditions",
    TREASURY_MANAGEMENT_AGREEMENT: "TreasuryManagementAgreement",
    CDARS_DOCUMENTS: "CdarsDocuments",
    ICS_DOCUMENTS: "IcsDocuments",
    ARIZONA_IOLTA_NOTIFICATION_TO_APPROVED_FI: "ArizonaIoltaNotificationToApprovedFi",
    COLORADO_COLTAF_ENROLLMENT_FORM: "ColoradoColtafEnrollmentForm",
    ILLINOIS_IOLTA_NOTICE_TO_FI: "IllinoisIoltaNoticeToFi",
    LOUISIANA_IOLTA_NOTICE_OF_ENROLLMENT: "LouisianaIoltaNoticeOfEnrollment",
    MISSOURI_IOLTA_NOTICE_TO_FI_AND_W9: "MissouriIoltaNoticeToFiAndW9",
    OHIO_IOLTA_IOTA_ACCOUNT_OPENING_EMAIL: "OhioIoltaIotaAccountOpeningEmail",
    TENNESSEE_IOLTA_NOTICE_TO_FI: "TennesseeIoltaNoticeToFi",
    INCOME_STATEMENTS_CURRENT_YEAR_TO_DATE: "IncomeStatementsCurrentYearToDate",
    BALANCE_SHEET_LAST_2_YEARS: "BalanceSheetLast2Years",
    PERSONAL_TAX_RETURNS_LAST_2_YEARS: "PersonalTaxReturnsLast2Years",
    BUSINESS_TAX_RETURNS_LAST_2_YEARS: "BusinessTaxReturnsLast2Years",
    OTHER_DOCUMENTS: "OtherDocuments",
  },
  PERSONAL_ACCOUNT_RISK_REVIEW: {
    LOCATION: "Location",
    NSF_HISTORY: "NsfHistory",
    NEGATIVE_SOCIAL_MEDIA_CHECK: "NegativeSocialMediaCheck",
    ADDRESS_VERIFICATION: "AddressVerification",
  },
  LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW: {
    LOCATION: "Location",
    ACCEPTABLE_BUSINESS: "AcceptableBusiness",
    BANKRUPTCY: "Bankruptcy",
    BALANCE_EVER_BELOW_ZERO: "BalanceEverBelowZero",
    BAR_DISCIPLINARY_ACTION: "BarDisciplinaryAction",
    TIMES_ACCOUNT_OVERDRAWN: "TimesAccountOverdrawn",
    NEGATIVE_SOCIAL_MEDIA_CHECK: "NegativeSocialMediaCheck",
  },
  NON_LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW: {
    LOCATION: "Location",
    ACCEPTABLE_BUSINESS: "AcceptableBusiness",
    NSF_HISTORY: "NsfHistory",
    YEARS_IN_INDUSTRY: "YearsInIndustry",
    IN_GOOD_STANDING_SECRETARY_OF_STATE: "InGoodStandingSecretaryOfState",
    NEGATIVE_SOCIAL_MEDIA_CHECK: "NegativeSocialMediaCheck",
    ADDRESS_VERIFICATION: "AddressVerification",
    BENEFICIAL_OWNER_INFORMATION_COMPLETE: "BeneficialOwnerInformationComplete",
    BENEFICIAL_OWNER_1_CREDIT_SCORE: "BeneficialOwner1CreditScore",
    BENEFICIAL_OWNER_2_CREDIT_SCORE: "BeneficialOwner2CreditScore",
    BENEFICIAL_OWNER_3_CREDIT_SCORE: "BeneficialOwner3CreditScore",
    BENEFICIAL_OWNER_4_CREDIT_SCORE: "BeneficialOwner4CreditScore",
  },
  ORGANIZATION_ACCOUNT_ACCEPTABLE_USE: {
    SEND_RECEIVE_WIRES: "SendReceiveWires",
    PROHIBITED_ACTIVITIES: "ProhibitedActivities",
    STORAGE_OF_VALUED_CARDS: "StorageOfValuedCards",
    GAMBLING: "Gambling",
    LOTTERY_TICKETS: "LotteryTickets",
    ADULT_ENTERTAINMENT_FIREARMS: "AdultEntertainmentFirearms",
    MARIJUANA_INDUSTRY: "MarijuanaIndustry",
    CANNABIS_INVESTMENTS: "CannabisInvestments",
    ILLEGAL_SUBSTANCES: "IllegalSubstances",
    CRYPTO_EXCHANGES: "CryptoExchanges",
    CRYPTO_ACTIVITIES: "CryptoActivities",
    VIRTUAL_CURRENCY: "VirtualCurrency",
    DEFENSE_CONTRACTORS: "DefenseContractors",
    PRIVATE_ATMS: "PrivateATMs",
    CASHING_CHECKS: "CashingChecks",
    INITIAL_CASH_DEPOSIT: "InitialCashDeposit",
  },
  PERSONAL_ACCOUNT_ACCEPTABLE_USE: {
    FOR_BUSINESS: "ForBusiness",
    CASH_DEPOSITS: "CashDeposits",
    SEND_RECEIVE_WIRES: "SendReceiveWires",
  },
  ORGANIZATION_INFORMATION: {
    LEGAL_ORGANIZATION_NAME: "LegalOrganizationName",
    FICTITIOUS_ORGANIZATION_NAME: "FictitiousOrganizationName",
    ORGANIZATION_TYPE: "OrganizationType",
    EMPLOYER_IDENTIFICATION_NUMBER: "EmployerIdentificationNumber",
    STATE_OF_FORMATION: "StateOfFormation",
    YEAR_ESTABLISHED: "YearEstablished",
    ORGANIZATION_PHONE_NUMBER: "OrganizationPhoneNumber",
    ORGANIZATION_EMAIL_ADDRESS: "OrganizationEmailAddress",
    ORGANIZATION_WEBSITE_URL: "OrganizationWebsiteUrl",
    NAICS_CODE: "NaicsCode",
    ENTITY_OR_TRUST_HAS_25_PERCENT_OR_GREATER_OWNERSHIP_IN_ORGANIZATION:
      "EntityOrTrustHas25PercentOrGreaterOwnershipInOrganization",
    FICO_SBSS_SCORE: "FicoSbssScore",
  },
  ORGANIZATION_CONTACT_INFORMATION: {
    ORGANIZATION_PHYSICAL_ADDRESS_IS_SAME_AS_HOME_ADDRESS:
      "OrganizationPhysicalAddressIsSameAsHomeAddress",
    ORGANIZATION_PHYSICAL_ADDRESS: "OrganizationPhysicalAddress",
    ORGANIZATION_MAILING_ADDRESS_IS_SAME_AS_ORGANIZATION_PHYSICAL_ADDRESS:
      "OrganizationMailingAddressIsSameAsOrganizationPhysicalAddress",
    ORGANIZATION_MAILING_ADDRESS: "OrganizationMailingAddress",
  },
  EMPLOYMENT_INFORMATION: {
    EMPLOYMENT_TYPE: "EmploymentType",
    EMPLOYER: "Employer",
    JOB_TITLE: "JobTitle",
    LENGTH_OF_EMPLOYMENT_YEARS: "LengthOfEmploymentYears",
    ATTORNEY_BAR_NUMBER: "AttorneyBarNumber",
  },
  PERSON_INFORMATION: {
    FIRST_NAME: "FirstName",
    MIDDLE_NAME: "MiddleName",
    LAST_NAME: "LastName",
    DATE_OF_BIRTH: "DateOfBirth",
    SOCIAL_SECURITY_NUMBER: "SocialSecurityNumber",
    PHONE_NUMBER: "PhoneNumber",
    EMAIL_ADDRESS: "EmailAddress",
    HOME_ADDRESS: "HomeAddress",
  },
  DIGITAL_BANKING_INFORMATION: {
    HAS_DIGITAL_BANKING: "HasDigitalBanking",
    DIGITAL_BANKING_USERNAME: "DigitalBankingUsername",
    DIGITAL_BANKING_ROLE: "DigitalBankingRole",
    DIGITAL_BANKING_EMAIL_ADDRESS: "DigitalBankingEmailAddress",
    DIGITAL_BANKING_PHONE_NUMBER: "DigitalBankingPhoneNumber",
  },
  DEBIT_CARD_INFORMATION: {
    HAS_DEBIT_CARD: "HasDebitCard",
    DEBIT_CARD_NAME_DISPLAYED: "DebitCardNameDisplayed",
    BUSINESS_NAME_DISPLAYED_ON_CARD: "BusinessNameDisplayedOnCard",
    DEBIT_CARD_MAILING_ADDRESS: "DebitCardMailingAddress",
    USE_HOME_ADDRESS_FOR_DEBIT_CARD_MAILING_ADDRESS: "UseHomeAddressForDebitCardMailingAddress",
  },
  GOVERNMENT_ID_INFORMATION: {
    CAN_PROVIDE_GOVERNMENT_ID_INFORMATION: "CanProvideGovernmentIdInformation",
    IS_US_CITIZEN: "IsUsCitizen",
    GOVERNMENT_ID_TYPE: "GovernmentIdType",
    GOVERNMENT_ID_NUMBER: "GovernmentIdNumber",
    GOVERNMENT_ID_ISSUER_STATE: "GovernmentIdIssuerUsState",
    GOVERNMENT_ID_ISSUER_COUNTRY: "GovernmentIdIssuerCountry",
    GOVERNMENT_ID_EXPIRY: "GovernmentIdExpiry",
    IS_PHYSICAL_ADDRESS_DIFFERENT_THAN_ID_ADDRESS: "IsPhysicalAddressDifferentThanIdAddress",
    REASON_PHYSICAL_ADDRESS_IS_DIFFERENT_THAN_ID_ADDRESS:
      "ReasonPhysicalAddressIsDifferentThanIdAddress",
    OTHER_REASON_PHYSICAL_ADDRESS_IS_DIFFERENT_THAN_ID_ADDRESS:
      "OtherReasonPhysicalAddressIsDifferentThanIdAddress",
  },
  SECURITY_QUESTIONS_INFORMATION: {
    SECURITY_QUESTION_1: "SecurityQuestion1",
    SECURITY_ANSWER_1: "SecurityAnswer1",
    SECURITY_QUESTION_2: "SecurityQuestion2",
    SECURITY_ANSWER_2: "SecurityAnswer2",
    SECURITY_QUESTION_3: "SecurityQuestion3",
    SECURITY_ANSWER_3: "SecurityAnswer3",
  },
  E_STATEMENTS_OPT_IN: {
    IS_E_STATEMENTS_OPT_IN_ENABLED: "IsEStatementsOptInEnabled",
  },
  CHECKS_OPT_IN: {
    IS_CHECKS_OPT_IN_ENABLED: "IsChecksOptInEnabled",
  },
  WIRES_OPT_IN: {
    IS_WIRES_OPT_IN_ENABLED: "IsWiresOptInEnabled",
    WIRE_TYPE_AS_LIST: "WireTypes_AsList",
    ESTIMATED_QUANTITY_OF_WIRES_PER_MONTH: "EstimatedQuantityOfWiresPerMonth",
    AVERAGE_DOLLAR_AMOUNT_PER_WIRE: "AverageDollarAmountPerWire",
    ESTIMATED_TOTAL_WIRE_DOLLAR_AMOUNT_PER_MONTH: "EstimatedTotalWireDollarAmountPerMonth",
  },
  ACH_OPT_IN: {
    IS_ACH_OPT_IN_ENABLED: "IsAchOptInEnabled",
    APPLICABLE_SEC_CODES_AS_LIST: "ApplicableSecCodes_AsList",
    ACH_PURPOSES_AS_LIST: "AchPurposes_AsList",
    AVERAGE_DOLLAR_AMOUNT_OF_ACH_TRANSACTIONS_PER_DAY: "AverageDollarAmountOfAchTransactionsPerDay",
    TOTAL_ACH_AMOUNT_IN_DOLLARS_PER_MONTH: "TotalAchAmountInDollarsPerMonth",
    ESTIMATED_QUANTITY_OF_ACH_TRANSACTIONS_PER_MONTH: "EstimatedQuantityOfAchTransactionsPerMonth",
    MAXIMUM_DOLLAR_AMOUNT_OF_ACH_TRANSACTIONS_PER_DAY: "MaximumDollarAmountOfAchTransactionsPerDay",
  },
  POSITIVE_PAY_OPT_IN: {
    IS_POSITIVE_PAY_OPT_IN_ENABLED: "IsPositivePayOptInEnabled",
    DEFAULT_POSITIVE_PAY_DECISION: "DefaultPositivePayDecision",
  },
  REMOTE_DEPOSIT_SCANNER_OPT_IN: {
    IS_REMOTE_DEPOSIT_SCANNER_OPT_IN_ENABLED: "IsRemoteDepositScannerOptInEnabled",
    COMPUTER_TYPE: "ComputerType",
  },
  CDARS_OPT_IN: {
    IS_CDARS_OPT_IN_ENABLED: "IsCdarsOptInEnabled",
  },
  INSURED_CASH_SWEEP_OPT_IN: {
    IS_INSURED_CASH_SWEEP_OPT_IN_ENABLED: "IsInsuredCashSweepOptInEnabled",
  },
} as const;

export const buildComplexFieldKey = (parentFieldKey: string, complexFieldKey: string) => {
  return `${parentFieldKey}__${complexFieldKey}`;
};

// Type to get all possible field key values
export type FieldKey =
  (typeof FIELD_KEYS)[keyof typeof FIELD_KEYS][keyof (typeof FIELD_KEYS)[keyof typeof FIELD_KEYS]];
